import { Component, computed, effect, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { UnitySessionStatus } from '@unity/clients';
import { OutsideContainerComponent } from '@unity/layouts/outside-container/outside-container.component';
import { NavigationService } from '@unity/services/navigation.service';

@Component({
  selector: 'unity-login-disabled-page',
  standalone: true,
  imports: [KENDO_LAYOUT, KENDO_BUTTON, RouterLink, OutsideContainerComponent],
  templateUrl: './login-disabled-page.component.html',
  styleUrl: './login-disabled-page.component.scss',
})
export class LoginDisabledPageComponent {
  private readonly navigationService = inject(NavigationService);

  public readonly $status = input(UnitySessionStatus[UnitySessionStatus.Unknown], { alias: 'status' });

  private readonly $isFailedSession = computed(() => {
    const statusAsString = this.$status();
    const statusAsEnum = UnitySessionStatus[statusAsString as keyof typeof UnitySessionStatus];
    return (statusAsEnum & UnitySessionStatus.Failed) === UnitySessionStatus.Failed;
  });

  public constructor() {
    effect(() => {
      const isFailedSession = this.$isFailedSession();
      if (!isFailedSession) {
        this.navigationService.navigate(['/login']);
      }
    });
  }
}
